import React from 'react';
import { motion } from 'framer-motion';
export function SolutionSection() {
  return <section className="relative z-10 px-6 py-16 md:py-24 text-center" data-id="element-78">
      <motion.div initial={{
      opacity: 0,
      scale: 0.95
    }} whileInView={{
      opacity: 1,
      scale: 1
    }} viewport={{
      once: true,
      margin: '-100px'
    }} transition={{
      duration: 0.8
    }} className="max-w-4xl mx-auto" data-id="element-79">
        <p className="text-sm md:text-base font-bold tracking-widest uppercase text-softPink mb-4 font-body" data-id="element-80">
          Presentamos:
        </p>

        <h2 className="text-4xl md:text-5xl lg:text-6xl font-bold text-gold font-heading mb-10 drop-shadow-[0_0_15px_rgba(245,197,66,0.3)]" data-id="element-81">
          "La Estrella que Más Brilla: Tú"
        </h2>

        <div className="max-w-2xl mx-auto space-y-6 text-lg md:text-xl text-warmWhite font-body" data-id="element-82">
          <p data-id="element-83">
            No es solo un libro de lectura. Es un plan de acompañamiento
            emocional de 30 días diseñado específicamente para mentes curiosas
            de 3 a 6 años.
          </p>

          <div className="relative inline-block mt-8 mb-4" data-id="element-84">
            <span className="relative z-10 text-2xl md:text-3xl font-bold text-white font-heading" data-id="element-85">
              Hemos creado un puente entre tú y tu peque.
            </span>
            <div className="absolute bottom-1 left-0 w-full h-3 bg-gold/40 -z-10 rounded-full transform -rotate-1" data-id="element-86"></div>
          </div>

          <p className="text-mutedPurple" data-id="element-87">
            Un espacio seguro, lleno de estrellas y magia, donde cada día
            descubrirán un nuevo "superpoder" interno.
          </p>
        </div>
      </motion.div>
    </section>;
}